// extracted by mini-css-extract-plugin
module.exports = {"contentStyles":"styles_contentStyles__uLE7o","image":"styles_image__2g2-9","placeholder":"styles_placeholder__AYDoH"};